<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form step2form">
      <div id="w-node-_739c8c02-240e-3d40-88fd-e518a11ee768-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('IDENTIFICATION_DOCUMENT')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('IDENTIFICATION_DOCUMENT')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'NATIONAL_ID_TYPE')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_POLICY_HOLDER.NATIONAL_ID_TYPE === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_POLICY_HOLDER.NATIONAL_ID_TYPE" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_1bd8e784-3408-0cbd-488f-c3fc398fd8de-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('NATIONAL_ID_NUMBER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('NATIONAL_ID_NUMBER')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.NATIONAL_ID" type="text" name="NATIONAL_ID_NUMBER" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-d7ab897f-808c-c2f0-b1c6-b25038963871-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('FIRST_NAME')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('FIRST_NAME')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.FIRST_NAME" type="text" name="FIRST_NAME" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_85b7f936-1def-693b-8a4f-e3a75ba3e026-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('LAST_NAME')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('LAST_NAME')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.LAST_NAME" type="text" name="LAST_NAME" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_743401ba-2f57-df92-66a7-6fba8d49e5b9-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('GENDER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('GENDER')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'GENDER_ID')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_POLICY_HOLDER.GENDER_ID === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_POLICY_HOLDER.GENDER_ID" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_11585a74-5651-c4ab-b781-acc99dbc3e06-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('BIRTHDATE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('BIRTHDATE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <datepicker-input v-model="data.CS_POLICY_HOLDER.BIRTH_DATE" classes="text_field_input text-field w-input" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('OCCUPATION')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label">{{ $t('OCCUPATION') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_POLICY_HOLDER.OCCUPATION_ID">
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'OCCUPATION_ID')" :key="item.VALUE" :value="item.VALUE">{{ item.TEXT }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_5331e370-9cda-364a-0676-5c748917324f-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('CITY_MUNICIPALITY_COMMUNE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label">{{ $t('CITY_MUNICIPALITY_COMMUNE') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_POLICY_HOLDER.CITY">
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLovsDep(data.ET_LOVS_DEP, 'CITY', data.CS_DRIVERS)" :key="item.VALUE" :value="item.VALUE">{{ item.TEXT }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_36dd5d5a-64ff-1011-dd35-66781e61260b-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('STREET')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label">{{ $t('STREET') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_POLICY_HOLDER.STREET">
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLovsDep(data.ET_LOVS_DEP, 'STREET', data.CS_POLICY_HOLDER)" :key="item.VALUE" :value="item.VALUE">{{
                item.TEXT
              }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_592417dc-b088-c5c5-5210-640e37c11fe7-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('BUILDING_NUMBER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('BUILDING_NUMBER')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.STREET_NUMBER" type="text" name="BUILDING_NUMBER" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div iid="w-node-ed6a4a2c-09fb-bf0e-6b5a-38a22f5f618c-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('APARTMENT_NUMBER')" rules="" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('APARTMENT_NUMBER')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.BUILDING_NUMBER" type="text" name="APARTMENT_NUMBER" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_0bd05793-4661-2f2a-b61b-299775967b41-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('POSTAL_CODE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('POSTAL_CODE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <input v-model="data.CS_POLICY_HOLDER.POSTAL_CODE" type="text" name="POSTAL_CODE" class="text_field_input text-field w-input" maxlength="256" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-c278334e-0b30-b79d-5aef-a085800bbe28-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('MOBILE_PHONE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('MOBILE_PHONE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <cleave-phone class="text_field_input text-field w-input" name="MOBILE_PHONE" v-model="data.CS_POLICY_HOLDER.MOB_PHONE_NO"></cleave-phone>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_67db1f82-c3f1-f84e-f53b-4dae0fdcdf4d-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('HOME_PHONE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('HOME_PHONE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <cleave-phone class="text_field_input text-field w-input" name="HOME_PHONE" v-model="data.CS_POLICY_HOLDER.HOME_PHONE_NO"></cleave-phone>
            <!-- <input v-model="data.CS_POLICY_HOLDER.HOME_PHONE_NO" type="text" class="text_field_input text-field w-input" maxlength="256" /> -->
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-f7f023fd-d5a5-5a82-26ea-57763580dd0c-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('WORK_PHONE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('WORK_PHONE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <cleave-phone class="text_field_input text-field w-input" name="WORK_PHONE" v-model="data.CS_POLICY_HOLDER.BUS_PHONE_NO"></cleave-phone>
            <!-- <input v-model="data.CS_POLICY_HOLDER.BUS_PHONE_NO" type="text" class="text_field_input text-field w-input" maxlength="256" /> -->
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_159f69a2-227f-cf16-9405-8eef5ff70898-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('POLICY_START_DATE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-9">
              <label class="field_label"><span v-html="$t('POLICY_START_DATE')"></span></label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            <!-- <help-text /> -->
          </div>
          <div class="div_form_cell">
            <datepicker-input v-model="data.CS_POLICY.START_DATE" :config="{ minDate: 'today'}" classes="text_field_input text-field w-input" />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-156b8f0a" class="form_field">
        <validation-provider class="w-100" :name="$t('POLICY_DURATION')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-9">
              <label class="field_label">{{ $t('POLICY_DURATION') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-3"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_POLICY.PERIOD" disabled>
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'PERIOD')" :key="item.VALUE" :value="item.VALUE">{{ item.TEXT }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <button type="submit" id="w-node-_7143e79d-3470-f95c-b9b4-c693e46cb25e-156b8f0a" class="submit-button submit-button-2 main_button w-button">{{ $t('CONTINUE') }}</button>
    </form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    submitForm() {
      // console.log(this.$store.state);
      this.$emit('next');
      console.log('submitted');
    }
  }
};
</script>
